import script from "./VariantRow.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__